import { Button } from 'antd';
import React from 'react';

const OkCancelButtons = ({
  loading,
  onCancel,
  // onOk,
  cancelText = 'cancel',
  okText,
}: {
  loading?: boolean;
  onCancel: () => void;
  // onOk: () => void;
  okText: string;
  cancelText?: string;
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button
        disabled={loading}
        type='default'
        size='large'
        onClick={() => onCancel()}
        style={{
          display: 'inline-flex',
          width: '30%',
          justifyContent: 'center',
          alignItems: 'center',
          height: 80,
        }}>
        {cancelText}
      </Button>
      <Button
        loading={loading}
        size='large'
        type='primary'
        htmlType='submit'
        style={{
          display: 'inline-flex',
          width: '68%',
          justifyContent: 'center',
          alignItems: 'center',
          height: 80,
        }}>
        {okText}
      </Button>
    </div>
  );
};

export default OkCancelButtons;
